<div class="header-landing">
    <img [src]="background" class="header-image" alt="Landing image" (error)="getRandomImage($event)">
    <div class="content">
      <ng-template #filterTitle>
        <h2 class="title" i18n="@@headerlanding_filter_x_alojamiento_en_y">{{entity?.name || '...' | titlecase}}!</h2>
      </ng-template>
      <h2 *ngIf="!seo; else filterTitle" class="title" i18n="@@headerlanding_alojamientos_en_x">Hoteles y Alojamientos en {{entity?.name || '...' | titlecase}}!</h2>
      <ng-container *ngIf="!!total && total > 0">
        <h3 class="subtitle" i18n="@@headerlanding_tenemos_mas_de_x_ofertas_de_alojamientos_para_vos">Tenemos más de {{total}} ofertas de alojamientos para vos</h3>
      </ng-container>
      <am-search-widget [section]="'results'"></am-search-widget>
    </div>
  </div>  